import { Component, ViewEncapsulation } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'res-end-user-license-agreement-modal',
  templateUrl: './end-user-license-agreement-modal.component.html',
  styleUrls: ['./end-user-license-agreement-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EndUserLicenseAgreementModalComponent extends BaseModalComponent {

  modalClass = 'end-user-license-agreement-modal';
  modalAutomationId = 'end-user-license-agreement';

  constructor(private modalService: BsModalService,
    private endUserLicenseAgreementModalRef: BsModalRef
  ) {
    super(modalService, endUserLicenseAgreementModalRef)
  }

}
